import React from "react";
import { ListItem, ListItemAvatar, ListItemText } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import styles from "../styles";
import LinkLocation from "./ListLocation";

type Props = {
    icon: React.ReactChildren,
    primaryText: string,
    data: Object,
};

const ListDetail = ({ icon, primaryText, data }: Props) => {
    const classes = makeStyles(styles)();

    return (
        <ListItem className={classes.list}>
            <ListItemAvatar>{icon}</ListItemAvatar>
            <ListItemText
                primary={primaryText}
                secondary={
                    data && data.length > 0 ? (
                        <LinkLocation clsName={classes.link} data={data} />
                    ) : null
                }
            />
        </ListItem>
    );
};
export default ListDetail;
